import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../../mocks/create-time-series-mock-data';

export const PUDO_TRANSACTION_VOLUME_LINE_CHART_MOCK_DATA: Chart = createSingleSeriesTimeSeriesMockData({
    scale: 0.65,
    seriesName: 'PuDo transactions'
});
